module.exports = "/fonts/Guyhoquet-Bold.woff2?d5fcfdb2bd30926dd4ba71d80672c0be";